type ProgressionArrowIconProps = {
  className?: string;
};

export const ProgressionArrow = ({ className }: ProgressionArrowIconProps) => (
  <svg
    width="140"
    height="10"
    viewBox="0 0 147 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M141 1L145 5L141 9"
      stroke="#D1D1D1"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1 5L145 4.99999"
      stroke="#D1D1D1"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
